import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "TruckCircle",
  "use": "TruckCircle-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" role=\"img\" id=\"TruckCircle\">\n  <circle cx=\"16\" cy=\"16\" r=\"16\" fill=\"#1F9CC6\" />\n  <path d=\"M21.333 13.333h-2v-2.667H10c-.733 0-1.333.6-1.333 1.334v7.333H10c0 1.107.893 2 2 2s2-.893 2-2h4c0 1.107.893 2 2 2s2-.893 2-2h1.333V16l-2-2.667zm-9.333 7c-.553 0-1-.446-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1 0 .554-.447 1-1 1zm9-6L22.307 16h-2.974v-1.667H21zm-1 6c-.553 0-1-.446-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1 0 .554-.447 1-1 1z\" fill=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol